<template>
  <section class="sec-summary">
    <div class="module_title">
      <span class="en">{{ en }}</span>
      <span class="num" :class="`num_${index}`" />
      <span class="tit">内容介绍</span>
      <span class="en">{{ en }}</span>
    </div>
    <div class="summary-main" v-html="data" />
  </section>
</template>
<script>
export default {
  data() {
    return {}
  },
  props: {
    en: {
      type: String,
      default: '',
    },
    index: {
      type: Number,
      default: 1,
    },
    data: {
      type: String,
      default: '',
    },
  },
  methods: {},
  mounted() {},
}
</script>
<style lang="less">
.sec-summary {
  position: relative;
  margin-bottom: 90px;
  .summary-main {
    width: 1059px;
    margin: 45px auto 0;
    font-family: HYYakuHei55W;
    line-height: 35px;
    font-size: 20px;
    color: #ffffff;
    p {
      margin-bottom: 15px;
    }
  }
}
</style>
